module.exports = __webpack_public_path__ + "static/media/Icon_zoomOut.8594c328.svg";